import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg, fmtDateTime } from "@/lib/api";
import { DemoBadge, Empty, PageHead, Spinner, StatusBadge, useFetch } from "@/components/common";

export function RequestTable({ items, onConfirm }) {
  if (!items?.length) return <Empty title="No requests" />;
  return (
    <div className="surface overflow-x-auto">
      <table className="data-table" data-testid="provider-requests-table">
        <thead><tr><th>Schedule</th><th>Service</th><th>Patient</th><th>Status</th><th /></tr></thead>
        <tbody>{items.map((r) => (
          <tr key={r.id} data-testid={`provider-request-${r.id}`}>
            <td className="whitespace-nowrap text-xs font-semibold">{fmtDateTime(r.scheduled_at)}</td>
            <td>{r.benefit_name} {r.is_demo && <DemoBadge />}<p className="text-[11px] text-slate-400">{r.delivery_mode === "ONLINE" ? "Online consultation" : "In person"}</p></td>
            <td className="text-xs">{r.beneficiary_name} · {r.beneficiary_relationship}</td>
            <td><StatusBadge status={r.status} /></td>
            <td className="whitespace-nowrap text-right">
              {r.status === "REQUESTED" && onConfirm && <button className="btn-secondary btn-sm mr-1" onClick={() => onConfirm(r.id)} data-testid={`provider-confirm-${r.id}`}>Confirm</button>}
              <Link to={`/provider/requests/${r.id}`} className="btn-ghost btn-sm" data-testid={`provider-open-${r.id}`}>Open</Link>
            </td>
          </tr>
        ))}</tbody>
      </table>
    </div>
  );
}

export default function ProviderHome() {
  const me = useFetch("/provider/me");
  const reqs = useFetch("/provider/requests");
  const confirm = async (id) => {
    try { await api.post(`/provider/requests/${id}/confirm`); toast.success("Appointment confirmed"); reqs.reload(); me.reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  if (me.loading && !me.data) return <Spinner />;
  const s = me.data?.stats || {};
  return (
    <div className="space-y-6">
      <PageHead eyebrow="Provider portal" title={me.data?.provider?.name || "Provider"} sub={`${me.data?.provider?.specialty || ""} · ${me.data?.provider?.clinic_name || ""}`} />
      <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
        {[["Requested", s.REQUESTED], ["Confirmed", s.CONFIRMED], ["Completed", s.COMPLETED], ["No-show", s.NO_SHOW]].map(([l, v]) => (
          <div key={l} className="surface p-4" data-testid={`provider-stat-${l.toLowerCase()}`}><p className="text-2xl font-extrabold">{v || 0}</p><p className="text-xs text-slate-500">{l}</p></div>
        ))}
      </div>
      <section><h2 className="mb-3 text-base font-bold">Assigned requests & appointments</h2>{reqs.loading && !reqs.data ? <Spinner /> : <RequestTable items={reqs.data} onConfirm={confirm} />}</section>
    </div>
  );
}

export function ProviderHistory() {
  const { data, loading } = useFetch("/provider/history");
  return (
    <div>
      <PageHead eyebrow="Provider portal" title="Service history" />
      {loading && !data ? <Spinner /> : <RequestTable items={data} />}
    </div>
  );
}
